export enum PaymentsActionTypes {
  CREATE_PAYMENT_REQUEST = 'CREATE_PAYMENT_REQUEST',
  CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS',
  CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE',
  GET_CURRENT_PLAN_REQUEST = 'GET_CURRENT_PLAN_REQUEST',
  GET_CURRENT_PLAN_SUCCESS = 'GET_CURRENT_PLAN_SUCCESS',
  GET_CURRENT_PLAN_FAILURE = 'GET_CURRENT_PLAN_FAILURE',
  GET_PAYMENT_USAGE_REQUEST = 'GET_PAYMENT_USAGE_REQUEST',
  GET_PAYMENT_USAGE_SUCCESS = 'GET_PAYMENT_USAGE_SUCCESS',
  GET_PAYMENT_USAGE_FAILURE = 'GET_PAYMENT_USAGE_FAILURE',
  CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST',
  CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE',
  CUSTOMER_PORTAL_REQUEST = 'CUSTOMER_PORTAL_REQUEST',
  CUSTOMER_PORTAL_SUCCESS = 'CUSTOMER_PORTAL_SUCCESS',
  CUSTOMER_PORTAL_FAILURE = 'CUSTOMER_PORTAL_FAILURE',
  CLEAR_PAYMENT_STATE = 'CLEAR_PAYMENT_STATE',
}

export interface CreatePaymentRequestAction {
  type: PaymentsActionTypes.CREATE_PAYMENT_REQUEST;
  payload: {
    product: string;
  };
}

export interface CreatePaymentSuccessAction {
  type: PaymentsActionTypes.CREATE_PAYMENT_SUCCESS;
  payload: {
    checkoutUrl?: string;
    message?: string;
    changeType?: string;
  };
}

export interface CreatePaymentFailureAction {
  type: PaymentsActionTypes.CREATE_PAYMENT_FAILURE;
  payload: string;
}

export interface PaymentUsagePlanLimits {
  emailSentHistory: number;
  campaign: number | null;
  segment: number | null;
  contact: number;
  workspace: number | null;
  teamMembers: number;
}

export interface PaymentUsageData {
  emailSentHistory: number;
  campaignCount: number;
  segmentCount: number;
  contactCount: number;
  workspaceCount: number;
  pendingUsage: boolean;
  planLimits: PaymentUsagePlanLimits;
}

export interface CurrentPlanData {
  plan?: string | null;
  status?: string | null;
  planStarts?: string | null;
  planEnds?: string | null;
}

export interface GetCurrentPlanRequestAction {
  type: PaymentsActionTypes.GET_CURRENT_PLAN_REQUEST;
}

export interface GetCurrentPlanSuccessAction {
  type: PaymentsActionTypes.GET_CURRENT_PLAN_SUCCESS;
  payload: CurrentPlanData;
}

export interface GetCurrentPlanFailureAction {
  type: PaymentsActionTypes.GET_CURRENT_PLAN_FAILURE;
  payload: string;
}

export interface GetPaymentUsageRequestAction {
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_REQUEST;
}

export interface GetPaymentUsageSuccessAction {
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_SUCCESS;
  payload: PaymentUsageData;
}

export interface GetPaymentUsageFailureAction {
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_FAILURE;
  payload: string;
}

export interface CancelSubscriptionRequestAction {
  type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_REQUEST;
}

export interface CancelSubscriptionSuccessAction {
  type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_SUCCESS;
  payload: {
    status: string;
  };
}

export interface CancelSubscriptionFailureAction {
  type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_FAILURE;
  payload: string;
}

export interface CustomerPortalRequestAction {
  type: PaymentsActionTypes.CUSTOMER_PORTAL_REQUEST;
}

export interface CustomerPortalSuccessAction {
  type: PaymentsActionTypes.CUSTOMER_PORTAL_SUCCESS;
  payload: {
    checkoutUrl: string;
  };
}

export interface CustomerPortalFailureAction {
  type: PaymentsActionTypes.CUSTOMER_PORTAL_FAILURE;
  payload: string;
}

export interface ClearPaymentStateAction {
  type: PaymentsActionTypes.CLEAR_PAYMENT_STATE;
}

export type PaymentsAction =
  | CreatePaymentRequestAction
  | CreatePaymentSuccessAction
  | CreatePaymentFailureAction
  | GetCurrentPlanRequestAction
  | GetCurrentPlanSuccessAction
  | GetCurrentPlanFailureAction
  | GetPaymentUsageRequestAction
  | GetPaymentUsageSuccessAction
  | GetPaymentUsageFailureAction
  | CancelSubscriptionRequestAction
  | CancelSubscriptionSuccessAction
  | CancelSubscriptionFailureAction
  | CustomerPortalRequestAction
  | CustomerPortalSuccessAction
  | CustomerPortalFailureAction
  | ClearPaymentStateAction;

export interface PaymentsState {
  currentPlanLoading: boolean;
  currentPlanError: string | null;
  currentPlan: CurrentPlanData | null;
  paymentUsageLoading: boolean;
  paymentUsageError: string | null;
  paymentUsage: PaymentUsageData | null;
  createPaymentLoading: boolean;
  createPaymentError: string | null;
  createPaymentMessage: string | null;
  createPaymentChangeType: string | null;
  cancelSubscriptionLoading: boolean;
  cancelSubscriptionError: string | null;
  customerPortalLoading: boolean;
  customerPortalError: string | null;
  checkoutUrl: string | null;
  selectedProduct: string | null;
  status: string | null;
}
